import React from 'react';
import { db } from '../../config-firebase/firebase.js';
import { getFirestore, getDoc, collection, query, where, getDocs, doc, onSnapshot } from 'firebase/firestore';
import { updateDoc, setDoc, addDoc } from '../../api/FirestoreInterceptor';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CheckDishesModal from '../Dishes/CheckdishesModal.js';
import AutoPayment from '../Payment/AutoPayment.js';
import '../../assets/styles/requestModal.css';
import {
  deleteRequestItem,
  getOneItemColleciton,
  getBtnData,
} from '../../api/Api.js';
import WarningMessages from '../WarningMessages';
import useLocalStorage from '../../Hooks/useLocalStorage.js';
import TotenRegisterPopup from './TotenRegisterPopup.js';
import PrintRequestCustomer from './PrintRequestCustomer';
import { GlobalContext } from '../../GlobalContext';
import DefaultComumMessage from '../Messages/DefaultComumMessage.js';
//import { cardClasses } from "@mui/material";
import { getAnonymousUser } from '../../Hooks/useEnsureAnonymousUser.js';
import BillFeedbackPopup from './BillFeedbackPopup';
import BillSummaryPopup from './BillSummaryPopup';
import { TRUE } from 'sass';
import DeliveryAddressPopup from './DeliveryAddressPopup';
import MessagePromotions from '../Promotions/MessagePromotions';
import Loading from '../Messages/Loading.js';
import OrderSentSuccessPopup from './OrderSentSuccessPopup';

const RequestModal = ({ pdv: pdvProp = false, manualTableNumber = '', setManualTableNumber = () => {} }) => {
  const [currentUser, setCurrentUser] = React.useState('');
  const [userData, setUserData] = React.useState(null);
  const [anonymousNickname, setAnonymousNickname] = React.useState('');
  const anonymousNicknameRef = React.useRef('');

  React.useEffect(() => {
    anonymousNicknameRef.current = anonymousNickname;
  }, [anonymousNickname]);

  React.useEffect(() => {
    if (userData?.fantasyName !== undefined) {
      setAnonymousNickname(userData.fantasyName || '');
    } else if (userData?.name && userData.name !== 'anonimo' && userData.name !== 'anonymous') {
      setAnonymousNickname('');
    }
  }, [userData?.id]);
  const [backorder, setBackorder] = React.useState(null);
  const [showDeliveryPopup, setShowDeliveryPopup] = React.useState(false);
  const [showDeliveryRegistrationPrompt, setShowDeliveryRegistrationPrompt] = React.useState(false);
  const [deliveryAddress, setDeliveryAddress] = React.useState(null);
  const [showAddressConfirmedMsg, setShowAddressConfirmedMsg] = React.useState(false);
  const [showSentOrderPopup, setShowSentOrderPopup] = React.useState(false);
  const [sentDishesConfirmation, setSentDishesConfirmation] = React.useState([]);

  const [item, setItem] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [disabledBtn, setDisabledBtn] = React.useState(true);
  const [finalPriceRequest, setFinalPriceRequest] = React.useState(null);
  // const [isToten, setIsToten] = React.useState(null); // Removido local, usando o global.isToten em seu lugar
  const [warningMsg, setWarningMsg] = React.useState(false); //Open message to before send request to next step
  const [totenMessage, setTotenMessage] = React.useState(false); //Open message to before send request to next step
  const [openCloseTotenPupup, setOpenCloseTotenPopup] = React.useState(false); //Open message to before send request to next step
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [autoPayment, setAutoPayment] = React.useState(false); //Habilita o pagamento automático
  const [errorPaymentMessage, setErrorPaymentMessage] = React.useState('false');
  const [autoPaymentMachineOn, setAutoPaymentMachineOn] = React.useState(true);
  const [totenRejectPaymentMessage, setTotenRejectPaymentMessage] = React.useState(false);
  const [billPopUpStep, setBillPopUpStep] = React.useState(0); // 0: closed, 1: ratings, 2: bill summary
  const [serviceRating, setServiceRating] = React.useState(0);
  const [foodRating, setFoodRating] = React.useState(0);
  const [waiterComment, setWaiterComment] = React.useState('');
  const [includeServiceCharge, setIncludeServiceCharge] = React.useState(true);
  const [isProcessingPayment, setIsProcessingPayment] = React.useState(false);
  const [activeRequestDocId, setActiveRequestDocId] = React.useState(null);
  const [benefitedClient, setBenefitedClient] = React.useState([]);
  const [benefitedClientEdited, setBenefitedClientEdited] = React.useState({});
  const [operation, setOperation] = React.useState('');
  const [currentDiscount, setCurrentDiscount] = React.useState(0);
  const [tableAssignedInThisSession, setTableAssignedInThisSession] = React.useState(false);

  // NOVO: Ref para salvar requisições localmente durante o longo processo no Toten (Resistente à perda de localStorage)
  const frozenRequestsForTotenCheckout = React.useRef(null);

  const calculateSafeTotemPrice = () => {
    let itemsToCalculate = [];
    if (frozenRequestsForTotenCheckout.current && frozenRequestsForTotenCheckout.current.length > 0) {
      itemsToCalculate = frozenRequestsForTotenCheckout.current;
    } else {
      const stored = localStorage.getItem('backorder');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed && parsed.length > 0) itemsToCalculate = parsed;
        } catch (e) { }
      }
    }
    
    if (itemsToCalculate.length > 0) {
      const price = itemsToCalculate.reduce((acc, el) => acc + (el.finalPrice || el.price || 0), 0);
      return Number(price.toFixed(2));
    }
    return finalPriceRequest;
  };

  const syncServiceChargeToFirestore = async (isEnabled) => {
    try {
      const currentTable = localStorage.getItem('tableNumber');
      if (userData && currentTable) {
        const q = query(
          collection(db, 'requests'),
          where('tableNumber', '==', currentTable),
          where('idUser', '==', userData.id),
          where('orderDelivered', '==', false)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const openOrderDoc = querySnapshot.docs[0];
          const requestDocRef = doc(db, 'requests', openOrderDoc.id);
          const itemsTotal = userData.request.reduce((acc, curr) => acc + curr.finalPrice, 0);
          const isServiceActive = Boolean(global?.serviceChargeActive);
          const percent = isServiceActive ? (Number(global?.serviceChargePercent) || 10) : 0;
          const serviceValue = (isEnabled && isServiceActive)
            ? Number((itemsTotal * (percent / 100)).toFixed(2))
            : 0;

          await updateDoc(requestDocRef, {
            serviceChargeEnabled: Boolean(isEnabled && isServiceActive),
            serviceChargePercent: percent,
            serviceChargeValue: serviceValue,
            finalPriceRequest: Number((itemsTotal + serviceValue).toFixed(2))
          });
        }
      }
    } catch (error) {
      console.error('Error syncing service charge:', error);
    }
  };

  const handleServiceChargeChange = (isEnabled) => {
    setIncludeServiceCharge(isEnabled);
    syncServiceChargeToFirestore(isEnabled);
  };

  const handlePaymentFinalization = async () => {
    setIsProcessingPayment(true);
    try {
      const currentTable = localStorage.getItem('tableNumber');
      if (userData && currentTable) {
        const q = query(
          collection(db, 'requests'),
          where('tableNumber', '==', currentTable),
          where('idUser', '==', userData.id),
          where('orderDelivered', '==', false)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const openOrderDoc = querySnapshot.docs[0];
          const requestDocRef = doc(db, 'requests', openOrderDoc.id);

          const itemsTotal = userData.request.reduce((acc, curr) => acc + curr.finalPrice, 0);
          const isServiceActive = Boolean(global?.serviceChargeActive);
          const percent = isServiceActive ? (Number(global?.serviceChargePercent) || 10) : 0;
          const serviceValue = (includeServiceCharge && isServiceActive) 
            ? Number((itemsTotal * (percent / 100)).toFixed(2)) 
            : 0;
          const totalFinalWithService = Number((itemsTotal + serviceValue).toFixed(2));

          const feedback = {};
          if (serviceRating > 0) feedback.service = serviceRating;
          if (foodRating > 0) feedback.product = foodRating;
          if (waiterComment.trim()) {
            const words = waiterComment.trim().split(/\s+/);
            const truncatedComment = words.length > 5 
              ? words.slice(0, 5).join(' ') + '...' 
              : waiterComment.trim();
            feedback.comment = truncatedComment;
            feedback.fullComment = waiterComment.trim();
          }

          const updateData = {};
          if (Object.keys(feedback).length > 0) {
            updateData.customerFeedback = feedback;
          }

          updateData.serviceChargeEnabled = Boolean(includeServiceCharge && isServiceActive);
          updateData.serviceChargePercent = percent;
          updateData.serviceChargeValue = serviceValue;
          updateData.finalPriceRequest = totalFinalWithService;

          // Adiciona a notificação de pagamento para o PDV
          updateData.paymentCall = {
            active: true,
            tableNumber: currentTable,
            callerName: userData.name || 'Cliente'
          };

          setActiveRequestDocId(openOrderDoc.id);
          await updateDoc(requestDocRef, updateData);
        }
      }
    } catch (error) {
      console.error('Error saving feedback:', error);
    }
  };

  // Close popups when order is finalized by waiter
  React.useEffect(() => {
    if (!isProcessingPayment || !activeRequestDocId) return;

    const requestDocRef = doc(db, 'requests', activeRequestDocId);

    const unsubscribe = onSnapshot(requestDocRef, (docSnap) => {
      if (docSnap.exists() && docSnap.data().orderDelivered === true) {
        // Order was finalized by waiter. Close the process.
        console.log('Active order finalized by waiter. Closing popups.');
        setIsProcessingPayment(false);
        setBillPopUpStep(0); // Fecha os popups completamente
        setActiveRequestDocId(null);
        // Preserva a mesa na sessão do cliente para novos pedidos
      }
    });

    return () => unsubscribe();
  }, [isProcessingPayment, activeRequestDocId, userData]);

  // Waiter Call Feature State
  const [waiterCallActive, setWaiterCallActive] = React.useState(false);
  const [waiterCallMessage, setWaiterCallMessage] = React.useState(false);

  const idPayerRef = React.useRef('');

  const [pdv, setPdv] = useLocalStorage('pdv', false);

  const navigate = useNavigate();
  const global = React.useContext(GlobalContext);

  React.useEffect(() => {
    if (global?.serviceChargeActive !== undefined) {
      setIncludeServiceCharge(Boolean(global.serviceChargeActive));
    }
  }, [global?.serviceChargeActive]);
  const isToten = Boolean(global?.isToten || localStorage.getItem('isToten') === 'true');
  const location = useLocation();
  const isAdminOrigin = !!location.state?.isAdminOrigin;
  const [stylePdv, setStylePdv] = React.useState(false);
  const methodPaymentRef = React.useRef('');
  const cpfForInvoiceRef = React.useRef('');
  const paymentTransactionDataRef = React.useRef(null);

  const isInsideAdmin = Boolean(
    typeof window !== 'undefined' && 
    window.location.pathname.startsWith('/admin')
  );

  const hasTableClientStorage = Boolean(
    typeof window !== 'undefined' &&
    !isInsideAdmin &&
    !global?.pdvRequest &&
    !pdvProp &&
    localStorage.getItem('tableNumber')
  );

  const isPdvActive = Boolean(
    !hasTableClientStorage && (
      pdvProp || 
      global?.pdvRequest || 
      isInsideAdmin ||
      (localStorage.getItem('pdv') === 'true' && !localStorage.getItem('tableNumber'))
    )
  );
  const isPdvMode = isPdvActive;

  const isTableClient = !isPdvActive && !global?.isToten && Boolean(localStorage.getItem('tableNumber'));
  const hasUnsentRequests = Boolean(
    userData?.request &&
    Array.isArray(userData.request) &&
    userData.request.some((item) => !item.sentToKitchen)
  );

  React.useEffect(() => {
    if (localStorage.hasOwnProperty('userMenu')) {
      const currentUserNew = JSON.parse(localStorage.getItem('userMenu'));
      setCurrentUser(currentUserNew.id);
    }
    // isToten removido localmente, agora é lido diretamente do global context (global.isToten)

    if (localStorage.hasOwnProperty('autoPaymentMachineOn')) {
      const autoPaymentAllow = JSON.parse(
        localStorage.getItem('autoPaymentMachineOn'),
      );
      autoPaymentAllow
        ? setAutoPaymentMachineOn(true)
        : setAutoPaymentMachineOn(false);
    }

    if (localStorage.hasOwnProperty('backorder')) {
      const raw = localStorage.getItem('backorder');
      let orderStoraged = [];

      if (raw) {
        try {
          orderStoraged = JSON.parse(raw);
        } catch (err) {
          console.warn("Valor inválido para 'backorder':", raw);
          orderStoraged = [];
        }
      }

      setBackorder(orderStoraged);
    }
  }, []);

  React.useEffect(() => {
    const isPdvStaff = Boolean(
      pdvProp || 
      global?.pdvRequest || 
      (isInsideAdmin && (window.location.pathname.includes('requestlist') || localStorage.getItem('pdv') === 'true')) ||
      (localStorage.getItem('pdv') === 'true' && !localStorage.getItem('tableNumber'))
    );

    if (isPdvStaff && !hasTableClientStorage) {
      setStylePdv(true);
    } else {
      setStylePdv(false);
    }
  }, [pdvProp, global?.pdvRequest, isInsideAdmin, hasTableClientStorage]);

  // Layout do cliente: rodapé (total + botões) fixo na base da tela e janela de pedidos com rolagem própria.
  // A altura da janela é medida em tempo real: do topo da lista até o topo do rodapé fixo.
  const sectionRef = React.useRef(null);
  const itemsScrollRef = React.useRef(null);
  const footerFixedRef = React.useRef(null);
  const [itemsMaxHeight, setItemsMaxHeight] = React.useState(null);
  const [footerBox, setFooterBox] = React.useState({ left: 0, width: 0 });

  React.useLayoutEffect(() => {
    if (stylePdv || isToten) return undefined;

    const recalc = () => {
      const section = sectionRef.current;
      const list = itemsScrollRef.current;
      const footer = footerFixedRef.current;
      if (!section || !list || !footer) return;

      const sectionRect = section.getBoundingClientRect();
      setFooterBox((prev) =>
        prev.left === sectionRect.left && prev.width === sectionRect.width
          ? prev
          : { left: sectionRect.left, width: sectionRect.width }
      );

      const listTop = list.getBoundingClientRect().top + window.scrollY;
      const available = Math.floor(window.innerHeight - listTop - footer.offsetHeight - 8);
      const next = Math.max(available, 100);
      setItemsMaxHeight((prev) => (prev === next ? prev : next));
    };

    recalc();
    window.addEventListener('resize', recalc);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(recalc) : null;
    if (observer) {
      if (footerFixedRef.current) observer.observe(footerFixedRef.current);
      if (sectionRef.current) observer.observe(sectionRef.current);
    }
    return () => {
      window.removeEventListener('resize', recalc);
      if (observer) observer.disconnect();
    };
  }, [stylePdv, userData]);

  React.useEffect(() => {
    if (userData && Array.isArray(userData.request)) {
      // Mudança aqui: Verificação de que userData existe e que request é um array
      requestFinalPrice(userData);
      if (userData.request.length > 0) {
        setDisabledBtn(false);
      } else {
        setDisabledBtn(true);
      }
      checkWaiterCallStatus();
    }
    console.log('userData mudou:', userData);
  }, [userData]);

  // Reset payment processing if order is cleared/paid by PDV (requests array becomes empty or null)
  React.useEffect(() => {
    if (!userData?.request || userData.request.length === 0) {
      if (billPopUpStep > 0) {
        setIsProcessingPayment(false);
        setBillPopUpStep(0);
        setActiveRequestDocId(null);
      }
    }
  }, [userData, billPopUpStep]);

  const allRequestsReady = React.useMemo(() => {
    if (!userData || !userData.request || userData.request.length === 0) return false;
    return userData.request.every(item => 
      !item.refusalRequested && (
        item.entregue || 
        item.status === 'Entregue' || 
        item.pronto || 
        item.status === 'Pronto'
      )
    );
  }, [userData]);

  const checkWaiterCallStatus = async () => {
    try {
      const targetUserId = userData?.id || currentUser;
      const currentTable = localStorage.getItem('tableNumber');
      if (isTableClient && targetUserId && currentTable) {
        const q = query(
          collection(db, 'requests'),
          where('idUser', '==', targetUserId),
          where('tableNumber', '==', currentTable),
          where('orderDelivered', '==', false)
        );
        // Usando onSnapshot para reagir ao chamado do garçom e sincronizar status dos pratos (pronto / entregue / recusado)
        onSnapshot(q, (snapshot) => {
          if (!snapshot.empty && snapshot.docs && snapshot.docs[0]) {
            const orderData = snapshot.docs[0].data();
            if (orderData.waiterCall && orderData.waiterCall.active) {
              setWaiterCallActive(true);
            } else {
              setWaiterCallActive(false);
            }

            // Sincroniza em tempo real o status dos pratos (pronto / entregue / recusado) da comanda aberta
            if (orderData.request && Array.isArray(orderData.request)) {
              setUserData((prev) => {
                if (!prev) return prev;
                const prevRequest = Array.isArray(prev.request) ? prev.request : [];
                const unsentItems = prevRequest.filter((u) => !u.sentToKitchen);

                const orderItems = orderData.request.map((match) => {
                  const isEntregue = Boolean(match.entregue);
                  const isPronto = Boolean(match.pronto);
                  const isRefusalRequested = Boolean(match.refusalRequested);
                  const refusalType = match.refusalType || '';
                  const refusalReason = match.refusalReason || '';
                  const statusLabel = isRefusalRequested
                    ? (refusalType === 'ajuste' ? 'Em ajuste na cozinha' : 'Prato recusado')
                    : (isEntregue ? 'Entregue' : (isPronto ? 'Pronto' : match.status || ''));

                  return {
                    ...match,
                    sentToKitchen: true,
                    entregue: isEntregue,
                    pronto: isPronto,
                    refusalRequested: isRefusalRequested,
                    refusalType,
                    refusalReason,
                    status: statusLabel,
                    tempo_levado: match.tempo_levado,
                  };
                });

                const newRequest = [...orderItems, ...unsentItems];
                const isDifferent =
                  prevRequest.length !== newRequest.length ||
                  prevRequest.some((pItem, i) => {
                    const nItem = newRequest[i];
                    return (
                      !nItem ||
                      pItem.id !== nItem.id ||
                      pItem.name !== nItem.name ||
                      pItem.pronto !== nItem.pronto ||
                      pItem.entregue !== nItem.entregue ||
                      pItem.refusalRequested !== nItem.refusalRequested ||
                      pItem.status !== nItem.status ||
                      pItem.sentToKitchen !== nItem.sentToKitchen
                    );
                  });

                if (!isDifferent) return prev;
                return { ...prev, request: newRequest };
              });
            }
          }
        });
      }
    } catch (error) {
      console.error('Error checking waiter call status', error);
    }
  };

  React.useEffect(() => {
    if (isTableClient && (userData?.id || currentUser)) {
      checkWaiterCallStatus();
    }
  }, [isTableClient, userData?.id, currentUser]);


  React.useEffect(() => {
    let unsubscribe;
    if (currentUser) {
      if (backorder && backorder.length > 0) {
        updateingNewCustomer(backorder);
      }
      const userDocRef = doc(db, 'user', currentUser);
      unsubscribe = onSnapshot(userDocRef, (userDocSnap) => {
        const data = userDocSnap.data();
        if (data) {
          setUserData((prev) => {
            const currentFantasy = anonymousNicknameRef.current !== '' ? anonymousNicknameRef.current : (data.fantasyName || '');
            return {
              ...data,
              id: userDocSnap.id,
              fantasyName: currentFantasy
            };
          });
          if (data.request && data.request.length > 0) {
            setDisabledBtn(true);
          }
        }
      });
    }
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [currentUser]);

  React.useEffect(() => {
    setIsSubmitting(false); // Reabilita o botão quando a rota mudar
  }, [location]);

  React.useEffect(() => {
    console.log('isSubmitting mudou:', isSubmitting);
  }, [isSubmitting]);

  //Take just one item of user collection

  async function fetchUser() {
    try {
      const activeId = userData?.id || currentUser;
      if (!activeId) return;
      console.log('Buscando usuário:', activeId);
      const userDocRef = doc(db, 'user', activeId);
      const userDocSnap = await getDoc(userDocRef);
      const data = userDocSnap.data();
      if (data) {
        setUserData((prev) => {
          const currentFantasy = anonymousNicknameRef.current !== '' ? anonymousNicknameRef.current : (data.fantasyName || '');
          return {
            ...data,
            id: userDocSnap.id,
            fantasyName: currentFantasy
          };
        });

        if (data.request && data.request.length > 0) {
          setDisabledBtn(true);
        }
      }
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
    }
  }

  const updateingNewCustomer = async (data) => {
    try {
      if (!data || data.length === 0) return;
      const userDocRef = doc(db, 'user', currentUser);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        // Se o documento do usuário já existir, atualiza o array request
        const currentRequests = userDocSnap.data().request || [];
        console.log('DATA É    ', data);
        console.log('currentRequests É    ', currentRequests);
        // Acrescente o novo objeto 'form' ao array 'requests'
        currentRequests.push(...data);
        console.log('form   ', currentRequests);

        // Atualize o documento com o novo array 'requests'
        await updateDoc(userDocRef, {
          request: currentRequests,
        });
      } else {
        // Se o documento do usuário não existir, cria o documento preservando mesclagem segura
        await setDoc(userDocRef, {
          name: 'anonimo',
          request: [...data],
        }, { merge: true });
      }
      fetchUser();
      localStorage.removeItem('backorder');
      setBackorder(null);
    } catch (error) {
      console.log(error);
    }
  };

  const requestFinalPrice = (data) => {
    if (data && data.request && data.request.length > 0) {
      let finalPrice = data.request
        .map((item) => item.finalPrice || item.price || 0)
        .reduce((ac, el) => ac + el, 0);

      setFinalPriceRequest(Number(finalPrice.toFixed(2)));
    } else {
      setFinalPriceRequest(0);
    }
  };

  const deleteRequest = async (index) => {
    const targetUserId = userData?.id || currentUser;
    if (!targetUserId) return;

    let updatedRequests = [];
    if (userData && Array.isArray(userData.request)) {
      updatedRequests = userData.request.filter((_, idx) => idx !== index);
      setUserData(prev => ({ ...prev, request: updatedRequests }));
      requestFinalPrice({ ...userData, request: updatedRequests });
    }

    try {
      const userRef = doc(db, 'user', targetUserId);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        await updateDoc(userRef, { request: updatedRequests });
      }
    } catch (err) {
      console.error('Erro ao deletar item:', err);
    }
  };

  const callDishesModal = (item) => {
    //chama o modal com o resumo do item
    if (item) {
      setItem(item);
      setModal(true);
    }
  };

  const openRegisterPopup = async () => {
    console.log("=== DEBUG CHECKOUT TOTEN ===");
    console.log("isToten (state local):", isToten);
    console.log("global.isToten (context):", global?.isToten);
    console.log("userData:", userData);
    console.log("userData?.name:", userData?.name);
    console.log("isTableClient:", isTableClient);
    console.log("localStorage isToten:", localStorage.getItem('isToten'));
    console.log("localStorage autoPaymentMachineOn:", localStorage.getItem('autoPaymentMachineOn'));

    if (isToten && (userData?.name === 'anonymous' || userData?.name === 'anonimo')) {
      if (userData?.request) {
        // Salvar os pedidos do anonymous na Ref da memória (Mais seguro) e no localStorage (Fallback)
        frozenRequestsForTotenCheckout.current = userData.request;
        localStorage.setItem('backorder', JSON.stringify(userData.request));

        try {
          // Limpa o carrinho do usuário atual (que é individual agora)
          const userDocRef = doc(db, 'user', userData.id);
          await updateDoc(userDocRef, { request: [] });
          console.log('Carrinho limpo para o usuário atual:', userData.id);
        } catch (error) {
          console.error(
            'Erro ao limpar carrinho do usuário anônimo:',
            error,
          );
        }
      }

      setOpenCloseTotenPopup(true);
      return;
    }

    // Se for Toten e o cliente for cadastrado (como Valmyr Tavares), 
    // não precisamos pedir apelido, mas iniciamos o fluxo de pagamento diretamente!
    if (isToten) {
      console.log("Iniciando auto pagamento diretamente para usuário cadastrado:", userData?.name);
      onChoose();
      return;
    }

    sendRequestToKitchen();
  };

  const isProcessing = React.useRef(false); // Bloqueia múltiplas execuções

  const handleDeliveryClick = () => {
    if (userData?.name && userData.name !== 'anonimo' && userData.name !== 'anonymous') {
      setShowDeliveryPopup(true);
    } else {
      setShowDeliveryRegistrationPrompt(true);
    }
  };

  const handleRegisterForDelivery = async () => {
    if (userData?.request) {
      frozenRequestsForTotenCheckout.current = userData.request;
      localStorage.setItem('backorder', JSON.stringify(userData.request));
      try {
        const userDocRef = doc(db, 'user', userData.id);
        await updateDoc(userDocRef, { request: [] });
      } catch (err) {}
    }
    logout();
  };

  const sendRequestToKitchen = async (e) => {
    console.log("=== sendRequestToKitchen chamada ===");
    console.log("isToten local:", isToten);
    console.log("pdv:", pdv);
    console.log("global.pdvRequest:", global?.pdvRequest);
    if (localStorage.hasOwnProperty('userMenu') || userData) {
      const currentUserNew = localStorage.getItem('userMenu') 
        ? JSON.parse(localStorage.getItem('userMenu')) 
        : null;

      const isPdvStaff = Boolean(
        pdv || 
        stylePdv || 
        isPdvMode || 
        (isInsideAdmin && (window.location.pathname.includes('requestlist') || localStorage.getItem('pdv') === 'true'))
      );

      if (isPdvStaff) {
        if (isProcessing.current) return;
        isProcessing.current = true;
        try {
          const userId = currentUserNew?.id || userData?.id;
          let data = userData;
          if (userId) {
            try {
              const fetched = await getOneItemColleciton('user', userId);
              if (fetched) data = { ...fetched, ...userData };
            } catch (fetchErr) {
              console.warn('Usando userData local para PDV:', fetchErr);
            }
          }
          const effectiveNickname = (anonymousNickname || data?.fantasyName || userData?.fantasyName || '').trim();
          if (effectiveNickname) {
            data = { ...data, fantasyName: effectiveNickname };
            if (userId) {
              try {
                const userDocRef = doc(db, 'user', userId);
                await updateDoc(userDocRef, { fantasyName: effectiveNickname });
              } catch (e) {
                console.warn('Erro ao sincronizar fantasyName no PDV:', e);
              }
            }
          }
          await addRequestUser(data || userData);
          global.setPdvRequest(false);
          global.setPdvMobileView('orders');
          navigate('/admin/requestlist');
        } catch (err) {
          console.error('Erro no envio PDV:', err);
        } finally {
          isProcessing.current = false;
        }
        return;
      } else if (isToten && isToten === true) {
        if (isProcessing.current) return;
        isProcessing.current = true;
        try {
          await addRequestUserToten(currentUserNew.id);
          setAutoPayment(false);
          setTotenMessage(true);
          // O Toten tem um tempo de espera visual antes de voltar ao início
          await new Promise(resolve => setTimeout(resolve, 5000));
          setTotenMessage(false);
          localStorage.removeItem('userMenu');
          global.setAuthorizated(false);
          navigate('/');
        } catch (err) {
          console.error('Erro no envio Toten:', err);
          setAutoPayment(false);
        } finally {
          isProcessing.current = false;
        }
        return;
      } else if (warningMsg) {
        if (isProcessing.current) return;
        if (isSubmitting) return;

        isProcessing.current = true;
        setIsSubmitting(true);

        try {
          const data = await getOneItemColleciton('user', currentUserNew.id);
          if (data) {
            await addRequestUser(data);
            // Fechamos o modal ANTES de liberar o botão, garantindo que o usuário não clique de novo
            setWarningMsg(false);
          }
        } catch (err) {
          console.error('Erro no envio Mobile:', err);
        } finally {
          setIsSubmitting(false);
          isProcessing.current = false;
        }
      } else {
        setWarningMsg(true);
      }
    }
  };

  const takeDataTime = () => {
    const now = new Date();
    const formattedDateTime = `${String(now.getDate()).padStart(
      2,
      '0',
    )}/${String(now.getMonth() + 1).padStart(
      2,
      '0',
    )}/${now.getFullYear()} - ${String(now.getHours()).padStart(
      2,
      '0',
    )}:${String(now.getMinutes()).padStart(2, '0')}:${String(
      now.getSeconds(),
    ).padStart(2, '0')}`;
    return formattedDateTime;
  };

  const cleanObject = (obj) => {
    if (Array.isArray(obj)) {
      return obj
        .filter((item) => item !== undefined && item !== null)
        .map((item) => cleanObject(item));
    }
    if (obj && typeof obj === 'object') {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, value]) => value !== undefined && value !== null)
          .map(([key, value]) => [key, cleanObject(value)]),
      );
    }
    return obj;
  };

  const calculateHistoricalCostsForItems = async (itemsArray, parentId = null) => {
      const allDishes = (await getBtnData('item')) || [];
      const allSideDishes = (await getBtnData('sideDishes')) || [];
      return (itemsArray || []).map((item, idx) => {
         let itemHistoricalCost = 0;
         if (item.sideDishes && item.sideDishes.length > 0 && Array.isArray(allSideDishes)) {
            item.sideDishes.forEach(sidedish => {
               const sd = allSideDishes.find(s => s && s.sideDishes === sidedish.name);
               if (sd) {
                  if (!sd.isBasic && sd.costPriceObj && Number(sd.costPriceObj.cost) <= Number(sd.price)) {
                     itemHistoricalCost += Number(sd.costPriceObj.cost);
                  }
               }
            });
         }
         let selectedDish = Array.isArray(allDishes) ? allDishes.find(d => d && d.id === item.id) : null;
         if (!selectedDish && item.name && Array.isArray(allDishes)) {
            selectedDish = allDishes.find(d => d && d.title && d.title.trim().toLowerCase() === item.name.trim().toLowerCase());
         }
         if (selectedDish) {
             const { costProfitMarginCustomized = {}, costPriceObj = {} } = selectedDish;
             if (!item.size || item.size === '') {
                 itemHistoricalCost += Number(costPriceObj.cost || 0);
             } else {
                 const currentCostData = Object.values(costProfitMarginCustomized || {}).find(priceObj => priceObj.label === item.size);
                 if (currentCostData) {
                     itemHistoricalCost += Number(currentCostData.cost || 0);
                 }
             }
         }
         const FinalMainprice = Number(item.finalPrice) || 0;
         const itemHistoricalProfit = FinalMainprice - itemHistoricalCost;
         return {
            ...item,
            sentToKitchen: true,
            sentToKitchenTime: item.sentToKitchenTime || takeDataTime(),
            parentRequestId: parentId,
            indexInRequest: idx,
            historicalCost: itemHistoricalCost,
            historicalProfit: itemHistoricalProfit
         };
      });
  };

  const finalizeOrderEdit = async () => {
    if (isProcessing.current || !global.orderBeingEdited) return;
    isProcessing.current = true;
    setIsSubmitting(true);

    try {
      const orderId = global.orderBeingEdited.id;
      const targetTable = global.orderBeingEdited.tableNumber || 
                          manualTableNumber || 
                          localStorage.getItem('tableNumber') || 
                          null;

      // 1. Busca pedido em requests
      const requestDocRef = doc(db, 'requests', orderId);
      const docSnap = await getDoc(requestDocRef);
      if (!docSnap.exists()) {
        alert("Pedido não encontrado na base de dados.");
        global.setOrderBeingEdited(null);
        global.setPdvRequest(false);
        global.setPdvMobileView('orders');
        navigate('/admin/requestlist');
        return;
      }

      const existingData = docSnap.data();
      const targetIdUser = existingData.idUser || userData?.id;

      // 2. Coleta itens do carrinho ou os que já estavam no pedido
      const currentItems = (userData && userData.request && userData.request.length > 0)
        ? userData.request
        : (existingData.request || []);

      const requestWithHistory = await calculateHistoricalCostsForItems(currentItems, orderId);

      const updatedItems = requestWithHistory.map((item, idx) => ({
        ...item,
        sentToKitchen: true,
        sentToKitchenTime: item.sentToKitchenTime || takeDataTime(),
        parentRequestId: orderId,
        indexInRequest: item.indexInRequest !== undefined ? item.indexInRequest : idx,
        pronto: Boolean(item.pronto),
        entregue: Boolean(item.entregue),
        deliveredByWaiter: Boolean(item.deliveredByWaiter)
      }));

      const totalItemsPrice = updatedItems.reduce(
        (acc, el) => acc + (Number(el.finalPrice || el.price) || 0),
        0
      );
      const discount = Number(existingData.discount || global.orderBeingEdited.discount || 0);
      const updatedFinalPrice = Number(Math.max(0, totalItemsPrice - discount).toFixed(2));

      // 3. Atualiza pedido no Firestore
      const updateData = {
        request: updatedItems,
        finalPriceRequest: updatedFinalPrice,
        done: true,
        isPdv: true,
        origin: 'pdv'
      };
      if (targetTable) {
        updateData.tableNumber = targetTable;
      }

      await updateDoc(requestDocRef, cleanObject(updateData));

      // 4. Limpa o carrinho de rascunho e apelido do usuário no Firestore
      setAnonymousNickname('');
      anonymousNicknameRef.current = '';

      const isTableOrder = Boolean(
        targetTable || 
        existingData.tableNumber || 
        existingData.mesa || 
        global.orderBeingEdited?.tableNumber
      );

      if (targetIdUser) {
        try {
          const userDocRef = doc(db, 'user', targetIdUser);
          if (isTableOrder) {
            const userSnap = await getDoc(userDocRef);
            if (userSnap.exists()) {
              const uData = userSnap.data();
              const existingUserRequests = Array.isArray(uData.request) ? uData.request : [];
              const otherItems = existingUserRequests.filter(
                (it) => it.parentRequestId && it.parentRequestId !== orderId
              );
              await updateDoc(userDocRef, { request: [...otherItems, ...updatedItems], fantasyName: '' });
            } else {
              await updateDoc(userDocRef, { request: updatedItems, fantasyName: '' });
            }
          } else {
            await updateDoc(userDocRef, { request: [], fantasyName: '' });
          }
        } catch (e) {
          console.warn('Erro ao atualizar carrinho do cliente editado:', e);
        }
      }

      // 5. Restaura sessão do PDV para usuário anônimo limpo e fecha a tela de pedidos
      global.setOrderBeingEdited(null);
      global.setPdvRequest(false);
      global.setPdvMobileView('orders');

      if (pdv || stylePdv || isPdvMode) {
        localStorage.removeItem('tableNumber');
        try {
          const anonUser = await getAnonymousUser();
          if (anonUser && anonUser.id) {
            try {
              const anonDocRef = doc(db, 'user', anonUser.id);
              await updateDoc(anonDocRef, { request: [] });
            } catch (eAnon) {}
            localStorage.setItem('userMenu', JSON.stringify({ id: anonUser.id, name: 'anonimo' }));
            setCurrentUser(anonUser.id);
            setUserData({ ...anonUser, request: [], name: 'anonimo' });
          } else {
            const fallbackId = `anon_${Date.now()}`;
            localStorage.setItem('userMenu', JSON.stringify({ id: fallbackId, name: 'anonimo' }));
            setCurrentUser(fallbackId);
            setUserData({ id: fallbackId, name: 'anonimo', request: [] });
          }
        } catch (e) {
          console.warn('Erro ao restaurar usuário anônimo no PDV:', e);
          const fallbackId = `anon_${Date.now()}`;
          localStorage.setItem('userMenu', JSON.stringify({ id: fallbackId, name: 'anonimo' }));
          setCurrentUser(fallbackId);
          setUserData({ id: fallbackId, name: 'anonimo', request: [] });
        }
      }

      if (typeof setManualTableNumber === 'function') {
        setManualTableNumber('');
      }
      setTableAssignedInThisSession(false);
      setAnonymousNickname('');
      navigate('/admin/requestlist');
    } catch (error) {
      console.error('Erro ao finalizar edição do pedido:', error);
      alert('Erro ao finalizar edição do pedido. Tente novamente.');
    } finally {
      isProcessing.current = false;
      setIsSubmitting(false);
    }
  };

  const addRequestUser = async (data) => {
    try {
      const targetTable = global.orderBeingEdited 
        ? (global.orderBeingEdited.tableNumber || localStorage.getItem('tableNumber')) 
        : (manualTableNumber || localStorage.getItem('tableNumber') || null);

      const parentIdForItems = global.orderBeingEdited ? global.orderBeingEdited.id : null;
      const requestWithHistory = await calculateHistoricalCostsForItems(data?.request, parentIdForItems);

      const totalItemsPrice = (data?.request || []).reduce((acc, el) => acc + (Number(el.finalPrice || el.price) || 0), 0);
      const calculatedPrice = Number((finalPriceRequest || totalItemsPrice).toFixed(2));

      const clientDisplayName = (() => {
        const registered = data?.name && data.name !== 'anonimo' && data.name !== 'anonymous'
          ? data.name.trim()
          : '';
        const nickname = (anonymousNickname || data?.fantasyName || '').trim();
        if (nickname) return nickname;
        if (registered) return registered;
        if (targetTable) return `Mesa ${targetTable}`;
        return 'PDV Balcão';
      })();

      const userNewRequest = {
        name: clientDisplayName,
        idUser: data?.id || currentUser || `anon_${Date.now()}`,
        done: true,
        orderDelivered: false,
        paymentDone: deliveryAddress ? false : undefined,
        deliveryAddress: deliveryAddress || null,
        isPdv: isPdvMode ? true : undefined,
        origin: isPdvMode ? 'pdv' : undefined,
        request: requestWithHistory,
        finalPriceRequest: calculatedPrice,
        idPayer: idPayerRef.current,
        dateTime: global.orderBeingEdited ? global.orderBeingEdited.dateTime : takeDataTime(),
        countRequest: global.orderBeingEdited ? global.orderBeingEdited.countRequest : await countingRequest(),
        tableNumber: targetTable || null,
      };

      setIsSubmitting(true);
      let cleanedUserNewRequest = null;
      if (userNewRequest) {
        cleanedUserNewRequest = cleanObject(userNewRequest);
        
        // Identifica se já existe pedido sendo editado especificamente ou pedido aberto da mesma mesa do mesmo cliente
        let existingRequestDocId = null;
        if (global.orderBeingEdited) {
          existingRequestDocId = global.orderBeingEdited.id;
        } else if (!isPdvMode && !stylePdv && !pdvProp && isTableClient && targetTable && cleanedUserNewRequest.idUser) {
          try {
            // Cliente no próprio celular: busca pedido aberto da mesma mesa e do mesmo cliente
            const requestsRef = collection(db, 'requests');
            const q = query(
              requestsRef,
              where('orderDelivered', '==', false)
            );
            const querySnapshot = await getDocs(q);
            const match = querySnapshot.docs.find(d => {
              const dData = d.data();
              return String(dData.tableNumber) === String(targetTable) && 
                     dData.idUser === cleanedUserNewRequest.idUser && 
                     !dData.orderDelivered;
            });
            if (match) {
              existingRequestDocId = match.id;
            }
          } catch (err) {
            console.error('Erro ao buscar pedido existente para mesclagem:', err);
          }
        }

        if (existingRequestDocId) {
          const targetId = existingRequestDocId;
          const requestDocRef = doc(db, 'requests', targetId);
          const docSnap = await getDoc(requestDocRef);

          if (docSnap.exists()) {
            const existingData = docSnap.data();
            const existingItems = existingData.request || [];

            if (global.orderBeingEdited) {
              const updatedItems = cleanedUserNewRequest.request.map((item, idx) => ({
                ...item,
                sentToKitchen: true,
                sentToKitchenTime: item.sentToKitchenTime || takeDataTime(),
                parentRequestId: targetId,
                indexInRequest: idx,
                pronto: Boolean(item.pronto),
                entregue: Boolean(item.entregue),
                deliveredByWaiter: Boolean(item.deliveredByWaiter)
              }));

              cleanedUserNewRequest.request = updatedItems;
              cleanedUserNewRequest.done = true;
              cleanedUserNewRequest.isPdv = true;
              cleanedUserNewRequest.origin = 'pdv';

              await updateDoc(requestDocRef, cleanedUserNewRequest);
            } else {
              const currentMaxIndex = existingItems.length > 0
                ? Math.max(...existingItems.map((item) => item.indexInRequest ?? 0))
                : -1;

              const newItemsPrepared = requestWithHistory.map((newItem, idx) => ({
                ...newItem,
                sentToKitchen: true,
                sentToKitchenTime: takeDataTime(),
                parentRequestId: targetId,
                indexInRequest: currentMaxIndex + 1 + idx,
                pronto: false,
                entregue: false,
                deliveredByWaiter: false
              }));

              const mergedItems = [...existingItems, ...newItemsPrepared];
              const addedPrice = newItemsPrepared.reduce((acc, el) => acc + (Number(el.finalPrice || el.price) || 0), 0);
              const updatedFinalPrice = Number(((Number(existingData.finalPriceRequest) || 0) + addedPrice).toFixed(2));

              const updateData = {
                request: mergedItems,
                finalPriceRequest: updatedFinalPrice,
                done: true,
              };

              if (isPdvMode) {
                updateData.isPdv = true;
                updateData.origin = 'pdv';
              } else if (existingData.isPdv !== undefined) {
                updateData.isPdv = existingData.isPdv;
              }

              if (existingData.origin !== undefined) {
                updateData.origin = existingData.origin;
              }

              await updateDoc(requestDocRef, cleanObject(updateData));

              // Sincroniza os itens com o documento do usuário da mesa para refletir na tela do cliente em tempo real
              const targetUserId = existingData.idUser || cleanedUserNewRequest.idUser;
              if (targetUserId) {
                try {
                  const userDocRef = doc(db, 'user', targetUserId);
                  await updateDoc(userDocRef, { request: mergedItems });
                } catch (e) {
                  console.warn('Erro ao atualizar doc de usuário da mesa:', e);
                }
              }
            }
          }

          global.setOrderBeingEdited(null);
          if (pdv || stylePdv || isPdvMode) {
            localStorage.removeItem('tableNumber');
          }
        } else {
          // Criando novo pedido (mesa nova ou balcão)
          const newItemsPrepared = requestWithHistory.map((item, idx) => ({
            ...item,
            sentToKitchen: true,
            sentToKitchenTime: takeDataTime(),
            indexInRequest: idx,
            pronto: false,
            entregue: false,
            deliveredByWaiter: false
          }));

          const totalItemsPrice = newItemsPrepared.reduce((acc, el) => acc + (Number(el.finalPrice || el.price) || 0), 0);

          const finalOrderToCreate = {
            ...cleanedUserNewRequest,
            request: newItemsPrepared,
            finalPriceRequest: Number((finalPriceRequest || totalItemsPrice).toFixed(2)),
            done: true,
            orderDelivered: false,
            isPdv: isPdvMode ? true : undefined,
            origin: isPdvMode ? 'pdv' : undefined,
            name: cleanedUserNewRequest.name || (targetTable ? `Mesa ${targetTable}` : 'PDV Balcão'),
            tableNumber: targetTable || null,
          };

          const docRef = await addDoc(collection(db, 'requests'), cleanObject(finalOrderToCreate));
          const finalItemsWithId = newItemsPrepared.map(item => ({
            ...item,
            parentRequestId: docRef.id
          }));
          await updateDoc(docRef, { request: finalItemsWithId });

          if (!isPdvMode) {
            const userDocRef = doc(db, 'user', cleanedUserNewRequest.idUser);
            if (cleanedUserNewRequest.tableNumber) {
              const updatedRequests = cleanedUserNewRequest.request.map((item, idx) => ({
                ...item,
                sentToKitchen: true,
                parentRequestId: docRef.id,
                indexInRequest: idx
              }));
              await updateDoc(userDocRef, { request: updatedRequests });
            } else {
              await updateDoc(userDocRef, { request: [] });
            }
          }
        }
      }
      setTotenMessage(false);

      if (isPdvMode) {
        setAnonymousNickname('');
        anonymousNicknameRef.current = '';

        try {
          const userDocRef = doc(db, 'user', data.id);
          await updateDoc(userDocRef, { request: [], fantasyName: '' });
        } catch (err) {
          console.error('Erro ao limpar carrinho PDV:', err);
        }

        try {
          const anonUser = await getAnonymousUser();
          if (anonUser && anonUser.id) {
            try {
              const anonDocRef = doc(db, 'user', anonUser.id);
              await updateDoc(anonDocRef, { request: [], fantasyName: '' });
            } catch (eAnon) {}
            localStorage.setItem('userMenu', JSON.stringify({ id: anonUser.id, name: 'anonimo' }));
            setCurrentUser(anonUser.id);
            setUserData({ ...anonUser, request: [], name: 'anonimo', fantasyName: '' });
          } else {
            const fallbackId = `anon_${Date.now()}`;
            localStorage.setItem('userMenu', JSON.stringify({ id: fallbackId, name: 'anonimo' }));
            setCurrentUser(fallbackId);
            setUserData({ id: fallbackId, name: 'anonimo', request: [], fantasyName: '' });
          }
        } catch (e) {
          const fallbackId = `anon_${Date.now()}`;
          localStorage.setItem('userMenu', JSON.stringify({ id: fallbackId, name: 'anonimo' }));
          setCurrentUser(fallbackId);
          setUserData({ id: fallbackId, name: 'anonimo', request: [], fantasyName: '' });
        }

        if (typeof setManualTableNumber === 'function') {
          setManualTableNumber('');
        }
        setTableAssignedInThisSession(false);
        global.setOrderBeingEdited(null);
        global.setPdvRequest(false);
        global.setPdvMobileView('orders');
        navigate('/admin/requestlist');
      } else {
        const storedTable = targetTable || localStorage.getItem('tableNumber') || userData?.tableNumber;
        if (storedTable && storedTable !== 'null' && storedTable !== 'undefined' && String(storedTable).trim() !== '') {
          navigate(`/${storedTable}`);
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      console.error('Erro ao adicionar pedido:', error);
      setIsSubmitting(false);
      isProcessing.current = false;
    }
  };

  //send request with finel price
  const addRequestUserToten = async (id) => {
    try {
      if (id) {
        setIsSubmitting(true);
        const data = await getOneItemColleciton('user', id);
        const storedRequests = localStorage.getItem('backorder');
        
        let previousRequests = [];
        if (frozenRequestsForTotenCheckout.current && frozenRequestsForTotenCheckout.current.length > 0) {
          previousRequests = frozenRequestsForTotenCheckout.current;
        } else if (storedRequests) {
          try {
            previousRequests = JSON.parse(storedRequests);
          } catch(e) {}
        }

        if (!previousRequests || previousRequests.length === 0) {
          if (data && Array.isArray(data.request) && data.request.length > 0) {
            previousRequests = data.request;
          }
        }

        const requestWithHistory = await calculateHistoricalCostsForItems(previousRequests, null);
        const methodPayment = methodPaymentRef.current;
        const cpfForInvoice = cpfForInvoiceRef.current;
        const paymentTransactionData = paymentTransactionDataRef.current;

        const userNewRequest = {
          name:
            data?.name === 'anonimo' || data?.name === 'anonymous'
              ? data.fantasyName
              : data?.name || 'Cliente Toten',
          idUser: data?.id || id,
          done: true,
          cpfForInvoice: cpfForInvoice ? cpfForInvoice : '',
          paymentDone:
            methodPayment &&
              methodPayment !== 'CASH' &&
              methodPayment !== 'desabled' &&
              methodPayment !== 'ABORTED' &&
              methodPayment !== 'REJECTED'
              ? true
              : false,
          paymentMethod: methodPayment,
          paymentDetails: paymentTransactionData ? {
            idPayer: paymentTransactionData.idPayer,
            cardBrand: paymentTransactionData.cardBrand,
            cardBrandCode: paymentTransactionData.cardBrandCode,
            nsu: paymentTransactionData.nsu,
            nsuAuthorizer: paymentTransactionData.nsuAuthorizer,
            authorizationCode: paymentTransactionData.authorizationCode,
            transactionDateTime: paymentTransactionData.transactionDateTime,
            acquirer: paymentTransactionData.acquirer,
            acquirerCNPJ: paymentTransactionData.acquirerCNPJ,
            value: paymentTransactionData.value,
            installments: paymentTransactionData.installments,
            terminalId: paymentTransactionData.terminalId,
            paymentMethod: paymentTransactionData.paymentMethod,
            paymentType: paymentTransactionData.paymentType,
            customerReceipt: paymentTransactionData.customerReceipt,
            shopReceipt: paymentTransactionData.shopReceipt,
          } : null,
          orderDelivered: false,
          request: requestWithHistory,
          finalPriceRequest: previousRequests.length > 0 ? Number(previousRequests.reduce((acc, el) => acc + (el.finalPrice || el.price || 0), 0).toFixed(2)) : finalPriceRequest,
          idPayer: idPayerRef.current,
          dateTime: global.orderBeingEdited ? global.orderBeingEdited.dateTime : takeDataTime(),
          countRequest: global.orderBeingEdited ? global.orderBeingEdited.countRequest : await countingRequest(),
          tableNumber: global.orderBeingEdited 
            ? (global.orderBeingEdited.tableNumber || localStorage.getItem('tableNumber')) 
            : (manualTableNumber || localStorage.getItem('tableNumber') || null),
        };

        if (userNewRequest) {
          const cleanedUserNewRequest = cleanObject(userNewRequest);
          if (global.orderBeingEdited) {
            const requestDocRef = doc(db, 'requests', global.orderBeingEdited.id);
            await updateDoc(requestDocRef, cleanedUserNewRequest);
            global.setOrderBeingEdited(null);
            if (pdv || stylePdv) {
              localStorage.removeItem('tableNumber');
            }

            const userDocRef = doc(db, 'user', id);
            if (global.orderBeingEdited.tableNumber) {
              const updatedRequests = (data?.request || []).map((item, idx) => ({
                ...item,
                sentToKitchen: true,
                parentRequestId: global.orderBeingEdited.id,
                indexInRequest: idx,
              }));
              await updateDoc(userDocRef, { request: updatedRequests });
            } else {
              await updateDoc(userDocRef, { request: [] });
            }
          } else {
            const docRef = await addDoc(
              collection(db, 'requests'),
              cleanedUserNewRequest,
            );
            const userDocRef = doc(db, 'user', id);
            if (cleanedUserNewRequest.tableNumber) {
              const updatedRequests = (data?.request || []).map((item, idx) => ({
                ...item,
                sentToKitchen: true,
                parentRequestId: docRef.id,
                indexInRequest: idx,
              }));
              await updateDoc(userDocRef, { request: updatedRequests });
            } else {
              await updateDoc(userDocRef, { request: [] });
            }
          }
          localStorage.removeItem('backorder');
        }
      }
    } catch (error) {
      console.error('Erro ao adicionar pedido Toten:', error);
      setIsSubmitting(false);
      isProcessing.current = false;
    }
  };

  const sendOrderToKitchenOnly = async () => {
    if (isProcessing.current) return;
    isProcessing.current = true;
    setIsSubmitting(true);

    try {
      const currentUserNew = localStorage.getItem('userMenu') 
        ? JSON.parse(localStorage.getItem('userMenu')) 
        : null;
      let data = userData;
      if (currentUserNew?.id) {
        try {
          const fetched = await getOneItemColleciton('user', currentUserNew.id);
          if (fetched) data = fetched;
        } catch (e) {
          console.warn('Usando userData local no sendOrderToKitchenOnly');
        }
      }

      if (data && data.request) {
        // Filtra apenas itens novos (ainda não enviados para a cozinha)
        const newItems = data.request.filter((item) => !item.sentToKitchen);

        if (newItems.length === 0) {
          isProcessing.current = false;
          setIsSubmitting(false);
          return; // Nada novo para enviar
        }

        // Agrupa os pratos enviados para exibir no popup de confirmação
        const sentSummary = newItems.reduce((acc, current) => {
          const name = current.name || current.title || 'Prato';
          const found = acc.find((x) => x.name === name);
          if (found) {
            found.count += 1;
          } else {
            acc.push({ name, count: 1 });
          }
          return acc;
        }, []);

        // Calcula o preco final apenas dos itens novos
        const newItemsPrice = newItems
          .map((item) => item.finalPrice)
          .reduce((ac, el) => ac + el, 0);

        const currentTable = manualTableNumber || localStorage.getItem('tableNumber');
        let orderAddedOrUpdated = false;

        // Tentar encontrar um pedido aberto apenas se estamos editando um pedido existente ou se for cliente de mesa individual
        let targetOpenOrderDoc = null;

        if (global.orderBeingEdited) {
          const requestDocRef = doc(db, 'requests', global.orderBeingEdited.id);
          const docSnap = await getDoc(requestDocRef);
          if (docSnap.exists()) {
            targetOpenOrderDoc = docSnap;
          }
        } else if (isTableClient && currentTable) {
          try {
            const requestsRef = collection(db, 'requests');
            const q = query(
              requestsRef,
              where('orderDelivered', '==', false)
            );
            const querySnapshot = await getDocs(q);
            const match = querySnapshot.docs.find(d => {
              const dData = d.data();
              return String(dData.tableNumber) === String(currentTable) && dData.idUser === data.id;
            });
            if (match) {
              targetOpenOrderDoc = match;
            }
          } catch (err) {
            console.error('Erro ao buscar pedido da mesa no sendOrderToKitchenOnly:', err);
          }
        }

        if (targetOpenOrderDoc) {
          const openOrderDoc = targetOpenOrderDoc;
          const openOrderData = openOrderDoc.data();

          // Calcula o próximo índice disponível para indexInRequest baseando-se no maior índice atual
          const currentMaxIndex = openOrderData.request && openOrderData.request.length > 0
            ? Math.max(...openOrderData.request.map((item) => item.indexInRequest || 0))
            : -1;

          // Prepara os novos itens com a flag de envio
          const newItemsPrepared = newItems.map((item, idx) => ({
            ...item,
            sentToKitchen: true,
            sentToKitchenTime: takeDataTime(),
            parentRequestId: openOrderDoc.id,
            indexInRequest: currentMaxIndex + 1 + idx,
            pronto: false,
            entregue: false,
            deliveredByWaiter: false
          }));

          // Junta os pratos que já estavam lá com os novos
          const updatedOrderRequests = [...(openOrderData.request || []), ...newItemsPrepared];
          const updatedPrice = Number(((openOrderData.finalPriceRequest || 0) + newItemsPrice).toFixed(2));

          const requestDocRef = doc(db, 'requests', openOrderDoc.id);
          const updateFields = {
            request: updatedOrderRequests,
            finalPriceRequest: updatedPrice,
            done: true,
          };

          if (isPdvMode) {
            updateFields.isPdv = true;
            updateFields.origin = 'pdv';
          } else if (openOrderData.isPdv !== undefined) {
            updateFields.isPdv = openOrderData.isPdv;
          }

          if (openOrderData.origin !== undefined) {
            updateFields.origin = openOrderData.origin;
          }

          // Se estamos editando, garantimos que o tableNumber não mude para null se o original tinha um
          if (global.orderBeingEdited && !currentTable && openOrderData.tableNumber) {
            updateFields.tableNumber = openOrderData.tableNumber;
          }

          await updateDoc(requestDocRef, cleanObject(updateFields));

          const isTableOrder = Boolean(currentTable || openOrderData?.tableNumber || global.orderBeingEdited?.tableNumber || data?.tableNumber);

          if (isPdvMode && !isTableOrder) {
            const userDocRef = doc(db, 'user', data.id);
            await updateDoc(userDocRef, { request: [] });
            setUserData({ ...data, request: [] });
          } else {
            const startIndex = openOrderData.request ? openOrderData.request.length : 0;
            let newItemsCount = 0;
            const updatedUserRequests = (data.request || []).map((uItem) => {
              if (!uItem.sentToKitchen) {
                const updatedItem = {
                  ...uItem,
                  sentToKitchen: true,
                  sentToKitchenTime: uItem.sentToKitchenTime || takeDataTime(),
                  parentRequestId: openOrderDoc.id,
                  indexInRequest: startIndex + newItemsCount,
                  pronto: Boolean(uItem.pronto),
                  entregue: Boolean(uItem.entregue),
                  deliveredByWaiter: Boolean(uItem.deliveredByWaiter)
                };
                newItemsCount++;
                return updatedItem;
              }
              return uItem;
            });

            const userDocRef = doc(db, 'user', data.id);
            await updateDoc(userDocRef, { request: updatedUserRequests });
            setUserData({ ...data, request: updatedUserRequests });
          }

          if (global.orderBeingEdited) {
            global.setOrderBeingEdited(null);
            if (pdv || stylePdv) {
              localStorage.removeItem('tableNumber');
            }
          }

          orderAddedOrUpdated = true;
        }

        // Se não encontrou pedido aberto (ou não tem mesa), cria um novo
        if (!orderAddedOrUpdated) {
          const clientDisplayName = (() => {
            const registered = data?.name && data.name !== 'anonimo' && data.name !== 'anonymous'
              ? data.name.trim()
              : '';
            const nickname = data?.fantasyName && data.fantasyName.trim()
              ? data.fantasyName.trim()
              : '';
            if (nickname) return nickname;
            if (registered) return registered;
            if (currentTable) return `Mesa ${currentTable}`;
            return 'PDV Balcão';
          })();

          const newRequestForKitchen = {
            name: clientDisplayName,
            idUser: data?.id || currentUser || `anon_${Date.now()}`,
            done: true,
            orderDelivered: false,
            paymentDone: deliveryAddress ? false : undefined,
            deliveryAddress: deliveryAddress || null,
            isPdv: isPdvMode ? true : undefined,
            origin: isPdvMode ? 'pdv' : undefined,
            request: newItems.map((item, idx) => ({
              ...item,
              sentToKitchen: true,
              sentToKitchenTime: takeDataTime(),
              indexInRequest: idx,
              pronto: false,
              entregue: false,
              deliveredByWaiter: false
            })),
            finalPriceRequest: newItemsPrice,
            idPayer: idPayerRef.current,
            dateTime: takeDataTime(),
            countRequest: await countingRequest(),
            tableNumber: manualTableNumber || currentTable || null,
          };
          
          if (manualTableNumber) {
            setTableAssignedInThisSession(true);
          }

          if (global.orderBeingEdited && !currentTable) {
            newRequestForKitchen.tableNumber = global.orderBeingEdited.tableNumber || null;
          }

          const cleanedUserNewRequest = cleanObject(newRequestForKitchen);
          const docRef = await addDoc(collection(db, 'requests'), cleanedUserNewRequest);

          // Atualiza o parentRequestId nos itens recém criados
          const itemsWithParentId = cleanedUserNewRequest.request.map(item => ({
            ...item,
            parentRequestId: docRef.id
          }));
          await updateDoc(doc(db, 'requests', docRef.id), { request: itemsWithParentId });

          const isTableOrder = Boolean(manualTableNumber || currentTable || global.orderBeingEdited?.tableNumber || data?.tableNumber);

          if (isPdvMode && !isTableOrder) {
            const userDocRef = doc(db, 'user', data.id);
            await updateDoc(userDocRef, { request: [] });
            setUserData({ ...data, request: [] });
          } else {
            const updatedUserRequests = (data.request || []).map((uItem) => {
              if (!uItem.sentToKitchen) {
                const itemIndexInBatch = newItems.indexOf(uItem);
                return {
                  ...uItem,
                  sentToKitchen: true,
                  sentToKitchenTime: uItem.sentToKitchenTime || takeDataTime(),
                  parentRequestId: docRef.id,
                  indexInRequest: itemIndexInBatch >= 0 ? itemIndexInBatch : 0,
                  pronto: false,
                  entregue: false,
                  deliveredByWaiter: false
                };
              }
              return uItem;
            });

            const userDocRef = doc(db, 'user', data.id);
            await updateDoc(userDocRef, { request: updatedUserRequests });
            setUserData({ ...data, request: updatedUserRequests });
          }
        }

        if (!isPdvMode) {
          setSentDishesConfirmation(sentSummary);
          setShowSentOrderPopup(true);
        }
      }
    } catch (error) {
      console.error('Erro ao enviar pedido para a cozinha:', error);
    } finally {
      isProcessing.current = false;
      setIsSubmitting(false);
      if (isInsideAdmin && (global.pdvRequest || global.orderBeingEdited)) {
        if (typeof setManualTableNumber === 'function') {
          setManualTableNumber('');
        }
        setTableAssignedInThisSession(false);
        global.setOrderBeingEdited(null);
        global.setPdvRequest(false);
        global.setPdvMobileView('orders');
        if (pdv || stylePdv) {
          localStorage.removeItem('tableNumber');
          try {
            const anonUser = await getAnonymousUser();
            if (anonUser && anonUser.id) {
              localStorage.setItem('userMenu', JSON.stringify({ id: anonUser.id, name: 'anonimo' }));
            }
          } catch (e) {}
        }
        navigate('/admin/requestlist');
      }
    }
  };

  const handleCallWaiter = async () => {
    if (isProcessing.current) return;
    isProcessing.current = true;
    try {
      const currentTable = localStorage.getItem('tableNumber');
      if (userData && currentTable) {
        const q = query(
          collection(db, 'requests'),
          where('tableNumber', '==', currentTable),
          where('idUser', '==', userData.id),
          where('orderDelivered', '==', false)
        );
        const querySnapshot = await getDocs(q);
        const waiterCallData = {
          active: true,
          callerName:
            userData.name === 'anonimo' || userData.name === 'anonymous'
              ? userData.fantasyName
              : userData.name,
          tableNumber: currentTable,
          timestamp: Date.now(),
        };

        if (!querySnapshot.empty) {
          const openOrderDoc = querySnapshot.docs[0];
          const requestDocRef = doc(db, 'requests', openOrderDoc.id);

          await updateDoc(requestDocRef, {
            waiterCall: waiterCallData,
          });
        } else {
          // Caso não exista pedido aberto, cria um pedido "vazio" apenas com o chamado
          const newRequest = {
            name:
              userData.name === 'anonimo' || userData.name === 'anonymous'
                ? userData.fantasyName
                : userData.name,
            idUser: userData.id,
            done: true,
            orderDelivered: false,
            request: [],
            finalPriceRequest: 0,
            dateTime: takeDataTime(),
            countRequest: await countingRequest(),
            tableNumber: currentTable,
            waiterCall: waiterCallData,
          };
          await addDoc(collection(db, 'requests'), newRequest);
        }
        setWaiterCallActive(true);
      }
    } catch (error) {
      console.error('Erro ao chamar o garçom:', error);
    } finally {
      isProcessing.current = false;
    }
  };

  const isSameDish = (a, b) => {
    if (a.name !== b.name) return false;
    if ((a.size || '') !== (b.size || '')) return false;

    const sidesA = a.sideDishes || [];
    const sidesB = b.sideDishes || [];
    if (sidesA.length !== sidesB.length) return false;

    const namesA = sidesA.map(s => s.name).sort();
    const namesB = sidesB.map(s => s.name).sort();
    for (let i = 0; i < namesA.length; i++) {
      if (namesA[i] !== namesB[i]) return false;
    }
    return true;
  };

  const getGroupedRequests = () => {
    if (!userData || !Array.isArray(userData.request)) return [];

    const grouped = [];

    userData.request.forEach((item, originalIndex) => {
      const isSentOrReady = 
        item.status === 'Pronto' || 
        item.status === 'Entregue' || 
        item.entregue || 
        item.pronto || 
        item.sentToKitchen ||
        item.refusalRequested;

      if (isSentOrReady) {
        grouped.push({
          ...item,
          originalIndices: [originalIndex],
          isGrouped: false
        });
      } else {
        const match = grouped.find(g =>
          !g.sentToKitchen &&
          !g.refusalRequested &&
          g.status !== 'Pronto' &&
          g.status !== 'Entregue' &&
          !g.entregue &&
          !g.pronto &&
          isSameDish(g, item)
        );

        if (match) {
          match.originalIndices.push(originalIndex);
          match.totalPrice = (match.totalPrice || match.finalPrice) + (item.finalPrice || item.price || 0);
        } else {
          grouped.push({
            ...item,
            originalIndices: [originalIndex],
            totalPrice: item.finalPrice || item.price || 0,
            isGrouped: true
          });
        }
      }
    });

    return grouped;
  };

  const decrementDish = async (originalIndices) => {
    if (!originalIndices || originalIndices.length === 0) return;
    const targetIndex = originalIndices[originalIndices.length - 1];
    await deleteRequest(targetIndex);
  };

  const duplicateDish = async (index) => {
    const targetUserId = userData?.id || currentUser;
    if (!targetUserId || !userData?.request) return;

    // Cria uma cópia do array original
    const updatedRequest = [...userData.request];

    // Duplica o item no índice fornecido
    const duplicatedItem = { ...updatedRequest[index] };

    // Insere o item duplicado logo após o original
    updatedRequest.splice(index + 1, 0, duplicatedItem);

    // Atualiza otimisticamente o state local para refletir na tela imediatamente!
    setUserData(prev => ({ ...prev, request: updatedRequest }));
    requestFinalPrice({ ...userData, request: updatedRequest });

    try {
      // Referência ao documento do usuário no Firestore
      const userDocRef = doc(db, 'user', targetUserId);
      const userSnap = await getDoc(userDocRef);
      if (userSnap.exists()) {
        await updateDoc(userDocRef, {
          request: updatedRequest,
        });
      } else {
        await setDoc(userDocRef, {
          name: userData?.name || 'anonimo',
          fantasyName: userData?.fantasyName || '',
          request: updatedRequest,
        }, { merge: true });
      }
      console.log('Array atualizado com sucesso no Firestore!');
    } catch (error) {
      console.error('Erro ao atualizar o array no Firestore:', error);
    }
  };
  const onChoose = async (selectedPayment, cpf, paymentData) => {
    if (!autoPaymentMachineOn) {
      await sendRequestToKitchen();
      return;
    }
    if (!autoPayment) {
      setAutoPayment(true);
      return;
    } else {
      if (selectedPayment === 'CASH') {
        sendRequestToKitchen();
        setAutoPayment(false);
      } else if (selectedPayment === 'desabled') {
        setAutoPayment(false);
        setErrorPaymentMessage(
          'Seu pagamento foi recusado. Você pode tentar novamente ou ir ao caixa e efetuar o pagamento com o/a atendente',
        );
        setTotenRejectPaymentMessage(true);
        setTimeout(() => {
          setTotenRejectPaymentMessage(false);
        }, 100000);
      } else if (selectedPayment === 'ABORTED') {
        console.log('Pagamento abortado pelo usuário.  ', selectedPayment);
        setAutoPayment(false);
        setErrorPaymentMessage('O seu pagamento foi cancelado');
        setTotenRejectPaymentMessage(true);
        setTimeout(() => {
          setTotenRejectPaymentMessage(false);
        }, 7000);
      } else {
        methodPaymentRef.current = selectedPayment;
        cpfForInvoiceRef.current = cpf;
        paymentTransactionDataRef.current = paymentData;
        sendRequestToKitchen();
      }
    }
  };

  const countingRequest = async () => {
    const requestData = await getBtnData('requests');
    const requestNumbers = requestData
      .filter((item) => item.countRequest !== undefined)
      .map((item) => item.countRequest);

    const maxRequestNumber =
      requestNumbers.length > 0 ? Math.max(...requestNumbers) : 0;

    return maxRequestNumber + 1;
  };
  //const userNewRequest = addRequestUser(currentUser);

  const handleRoute = () => {
    if (!stylePdv) {
      const table = localStorage.getItem('tableNumber');
      if (table) {
        navigate(`/${table}`);
      } else {
        navigate('/');
      }
    } else {
      global.setPdvRequest(false);
      navigate('/admin/requestlist');
      return;
    }
  };
  const logout = () => {
    if (global.orderBeingEdited) {
      alert("Você não pode trocar de cliente enquanto edita um pedido. Cancele ou finalize a edição primeiro.");
      return;
    }
    if (stylePdv) {
      navigate('/admin/customer', { state: { fromPdv: true } });
      return;
    }
    localStorage.removeItem('userMenu');
    global.setAuthorizated(false);
    navigate('/create-customer');
  };

  const cancelEditOrder = async () => {
    try {
      const isConfirmed = window.confirm("Tem certeza que deseja cancelar a edição? As adições ou remoções feitas no pedido não serão salvas.");
      if (!isConfirmed) return;

      if (global.orderBeingEdited && global.orderBeingEdited.id) {
        try {
          const reqSnap = await getDoc(doc(db, 'requests', global.orderBeingEdited.id));
          if (reqSnap.exists()) {
            const originalData = reqSnap.data();
            const targetIdUser = originalData.idUser || userData?.id;
            if (targetIdUser) {
              const userDocRef = doc(db, 'user', targetIdUser);
              if (originalData.tableNumber || originalData.mesa) {
                await updateDoc(userDocRef, { request: originalData.request || [] });
              } else {
                await updateDoc(userDocRef, { request: [] });
              }
            }
          }
        } catch (e) {
          console.warn('Erro ao limpar itens do usuário ao cancelar edição:', e);
        }
      }

      global.setOrderBeingEdited(null);
      global.setPdvRequest(false);
      global.setPdvMobileView('orders');
      if (pdv || stylePdv || isPdvMode) {
        localStorage.removeItem('tableNumber');
        try {
          const anonUser = await getAnonymousUser();
          if (anonUser && anonUser.id) {
            try {
              const anonDocRef = doc(db, 'user', anonUser.id);
              await updateDoc(anonDocRef, { request: [] });
            } catch (eAnon) {}
            localStorage.setItem('userMenu', JSON.stringify({ id: anonUser.id, name: 'anonimo' }));
            setCurrentUser(anonUser.id);
            setUserData({ ...anonUser, request: [], name: 'anonimo' });
          }
        } catch (e) {}
        setAnonymousNickname('');
      }
      if (typeof setManualTableNumber === 'function') {
        setManualTableNumber('');
      }
      navigate('/admin/requestlist');
    } catch (err) {
      console.error("Erro ao cancelar edição:", err);
    }
  };

  const handleAnonymousNameChange = (e) => {
    const newName = e.target.value;
    setAnonymousNickname(newName);
  };

  const handleAnonymousNameBlur = async () => {
    const trimmed = (anonymousNickname || '').trim();
    setUserData(prev => prev ? ({ ...prev, fantasyName: trimmed }) : prev);
    const targetUserId = userData?.id || currentUser;
    if (targetUserId) {
      try {
        const userDocRef = doc(db, 'user', targetUserId);
        await updateDoc(userDocRef, { fantasyName: trimmed });
      } catch (err) {
        console.error('Erro ao atualizar apelido do cliente anônimo:', err);
      }
    }
  };

  const handleFinalizeButtonClick = () => {
    if (global.orderBeingEdited) {
      finalizeOrderEdit();
      return;
    }

    if (stylePdv || isPdvMode) {
      const isRegisteredUser = userData?.name && userData.name !== 'anonimo' && userData.name !== 'anonymous';
      const effectiveNickname = (anonymousNickname || userData?.fantasyName || '').trim();
      const hasNickname = effectiveNickname.length > 0;
      const hasTable = (manualTableNumber && manualTableNumber.trim().length > 0) || 
                       localStorage.getItem('tableNumber') || 
                       global.orderBeingEdited?.tableNumber;

      if (!isRegisteredUser && !hasNickname && !hasTable) {
        alert("Preencha o número da mesa, o apelido do cliente ou selecione um cliente registrado antes de finalizar o pedido.");
        return;
      }

      sendRequestToKitchen();
      return;
    }

    if (deliveryAddress) {
      sendOrderToKitchenOnly();
    } else if (isTableClient) {
      setBillPopUpStep(1);
    } else {
      openRegisterPopup();
    }
  };

  const onClose = () => {
    setTotenRejectPaymentMessage(false);
    sendRequestToKitchen();
  };

  const onConfirm = () => {
    console.log('Confirmando mensagem de rejeição de pagamento do toten');
    setTotenRejectPaymentMessage(false);
    setAutoPayment(true);
  };
  return (
    <section
      ref={isToten ? undefined : sectionRef}
      className={`container-modal-request ${stylePdv ? 'pdv-change' : (isToten ? '' : 'customer-request-view')}`}
    >
      {isSubmitting && <Loading />}
      {global.orderBeingEdited && (
        <div style={{ backgroundColor: '#ff9800', padding: '10px', textAlign: 'center', fontWeight: 'bold', color: 'white', borderRadius: '5px', marginBottom: '10px' }}>
          Você está editando o pedido #{global.orderBeingEdited.countRequest}
          <button
            style={{ marginLeft: '15px', backgroundColor: '#2e7d32', color: 'white', padding: '6px 14px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={finalizeOrderEdit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Finalizando..." : "Finalizar Edição"}
          </button>
          <button
            style={{ marginLeft: '10px', backgroundColor: '#d32f2f', color: 'white', padding: '6px 12px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            onClick={cancelEditOrder}
            disabled={isSubmitting}
          >
            Cancelar Edição
          </button>
        </div>
      )}
      {openCloseTotenPupup && (
        <TotenRegisterPopup
          setOpenCloseTotenPopup={setOpenCloseTotenPopup}
          setCurrentUser={setCurrentUser}
          sendRequestToKitchen={sendRequestToKitchen}
          onChoose={onChoose}
          isSubmitting={isSubmitting}
        />
      )}
      {showSentOrderPopup && (
        <OrderSentSuccessPopup
          dishes={sentDishesConfirmation}
          tableNumber={manualTableNumber || localStorage.getItem('tableNumber')}
          onClose={() => setShowSentOrderPopup(false)}
        />
      )}
      {showDeliveryRegistrationPrompt && (
        <DefaultComumMessage
          msg="A entrega só pode ser feita para clientes cadastrados. Cadastre-se agora para receber seu pedido em casa!"
          onClose={() => setShowDeliveryRegistrationPrompt(false)}
          onConfirm={handleRegisterForDelivery}
          negativeResponse="Cancelar"
          affirmativeResponse="Cadastrar"
        />
      )}
      {showDeliveryPopup && (
        <DeliveryAddressPopup 
          customerName={userData?.name}
          onClose={() => setShowDeliveryPopup(false)}
          onSubmit={(address) => {
            setDeliveryAddress(address);
            setShowDeliveryPopup(false);
            setShowAddressConfirmedMsg(true);
          }}
        />
      )}
      {showAddressConfirmedMsg && (
        <DefaultComumMessage 
          msg="Endereço confirmado! Clique em Fazer Pedido (Entrega) para enviar à cozinha." 
          onConfirm={() => setShowAddressConfirmedMsg(false)}
          affirmativeResponse="Continuar"
        />
      )}
      {totenMessage && (
        <DefaultComumMessage msg="Acompanhe o seu pedido na Fila de pedidos que está na TV acima" />
      )}
      {totenRejectPaymentMessage && (
        <DefaultComumMessage
          msg={errorPaymentMessage}
          onClose={onClose}
          onConfirm={onConfirm}
          negativeResponse="Fechar e pagar com o atendente"
          affirmativeResponse="Tentar Novamente"
        />
      )}
      <div className="container-modalDihses-InCarrolse">
        {modal && <CheckDishesModal item={item} setModal={setModal} />}
      </div>
      {autoPayment && (
        <div className="container-autoPayment">
          <AutoPayment
            onChoose={onChoose}
            setIdPayer={(value) => (idPayerRef.current = value)}
            price={calculateSafeTotemPrice()}
            setAutoPayment={setAutoPayment}
            isSubmitting={isSubmitting}
          />
        </div>
      )}
      {warningMsg && (
        <WarningMessages
          message="Agora você pode ir ao caixa "
          customer={userData?.name}
          finalPriceRequest={finalPriceRequest}
          sendRequestToKitchen={sendRequestToKitchen}
          setWarningMsg={setWarningMsg}
          requests={userData.request}
          isSubmitting={isSubmitting}
        />
      )}

      {(!isToten && !stylePdv && global.hasClients && Number(global.packageTier) > 1 && !localStorage.getItem('tableNumber')) && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '10%', marginTop: '10px' }}>
          <button
            className="call-waiter-btn"
            style={{ 
              width: '150px',
              opacity: (isSubmitting || !userData || !userData.request || userData.request.length === 0) ? 0.7 : 1,
              cursor: (isSubmitting || !userData || !userData.request || userData.request.length === 0) ? 'not-allowed' : 'pointer'
            }}
            onClick={handleDeliveryClick}
            disabled={isSubmitting || !userData || !userData.request || userData.request.length === 0}
          >
            ENTREGA
          </button>
        </div>
      )}

      <p
        className="current-client"
        onClick={stylePdv ? logout : undefined}
        style={stylePdv ? { cursor: 'pointer' } : {}}
        title={stylePdv ? 'Clique para trocar de cliente' : ''}
      >
        <span>Cliente: </span>
        {userData?.name === 'anonimo' || userData?.name === 'anonymous'
          ? (anonymousNickname || userData?.fantasyName || 'Sem cadastro')
          : userData?.name}
        {localStorage.getItem('tableNumber') && (
          <span style={{ marginLeft: '15px', color: 'var(--title-font-color)' }}>
            Mesa: {localStorage.getItem('tableNumber')}
          </span>
        )}
      </p>

      {stylePdv && (!userData?.name || userData?.name === 'anonimo' || userData?.name === 'anonymous') && (
        <div style={{ textAlign: 'center', margin: '4px 0 8px 0' }}>
          <input
            type="text"
            placeholder="Apelido / Nome do cliente (Sem cadastro)"
            value={anonymousNickname}
            onChange={handleAnonymousNameChange}
            onBlur={handleAnonymousNameBlur}
            style={{
              padding: '6px 10px',
              borderRadius: '6px',
              border: '1px solid var(--btn-color)',
              textAlign: 'center',
              width: '85%',
              maxWidth: '260px',
              backgroundColor: 'white',
              color: '#333',
              fontSize: '0.88rem'
            }}
          />
        </div>
      )}

      {isTableClient && (
        <div className="table-actions-container call-waiter-container">
          <button
            className="call-waiter-btn"
            disabled={waiterCallActive || isSubmitting}
            onClick={handleCallWaiter}
          >
            {waiterCallActive ? "Garçom a caminho..." : "Chame o Garçom"}
          </button>

          {(!isPdvMode && !stylePdv && !global.orderBeingEdited) && (
            <button
              disabled={isSubmitting || !userData || !hasUnsentRequests}
              className={`send-request ${hasUnsentRequests ? 'btn-send-order-blinking' : ''}`}
              onClick={sendOrderToKitchenOnly}
            >
              {isSubmitting ? "ENVIANDO..." : "Enviar pedido"}
            </button>
          )}
        </div>
      )}

      <h3>Esses são os seus pedidos até o momento</h3>
      <div
        ref={isToten ? undefined : itemsScrollRef}
        className={(stylePdv || isToten) ? undefined : 'request-items-window'}
        style={(!stylePdv && !isToten && itemsMaxHeight) ? { maxHeight: `${itemsMaxHeight}px` } : undefined}
      >
      {userData &&
        Array.isArray(userData.request) &&
        userData.request.length > 0 ? (
        getGroupedRequests().map((item, index) => (
          <div className="individual-dishes my-3" key={index}>
            <h2 onClick={() => callDishesModal(item)} className="my-0">
              {item.name}
            </h2>
            <p className="dishes-price">
              R${' '}
              {(item.totalPrice || item.finalPrice).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            {item.refusalRequested ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <p className={`status-request-pend ${item.refusalType === 'ajuste' ? 'status-in-adjustment' : 'status-refused'}`} style={{ margin: 0 }}>
                  <span className="pulse-dot"></span>
                  {item.refusalType === 'ajuste' ? 'Em ajuste na cozinha' : 'Prato recusado'}
                </p>
                {item.refusalReason && (
                  <p style={{ fontSize: '0.78rem', color: '#dc2626', margin: '2px 0 0 0', maxWidth: '170px', textAlign: 'right', fontWeight: '500' }}>
                    Motivo: {item.refusalReason}
                  </p>
                )}
              </div>
            ) : item.entregue || item.status === 'Entregue' ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <p className="status-request-pend status-delivered" style={{ margin: 0 }}>
                  Entregue ✓
                </p>
                {item.tempo_levado && (
                  <p style={{ fontSize: '0.8rem', color: '#666', margin: 0 }}>{item.tempo_levado}</p>
                )}
              </div>
            ) : item.pronto || item.status === 'Pronto' ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <p className="status-request-pend status-ready" style={{ margin: 0 }}>
                  Pronto ✓
                </p>
                {item.tempo_levado && (
                  <p style={{ fontSize: '0.8rem', color: '#666', margin: 0 }}>{item.tempo_levado}</p>
                )}
              </div>
            ) : item.sentToKitchen ? (
              <p className="status-request-pend status-in-preparation">
                <span className="pulse-dot"></span>
                Em preparo
              </p>
            ) : item.originalIndices && item.originalIndices.length > 1 ? (
              <>
                <p className="status-request-pend status-pending-blinking">Qtd: {item.originalIndices.length}</p>
                <button type="button" className="qty-btn" aria-label="Diminuir" onClick={() => decrementDish(item.originalIndices)}>−</button>
                <button type="button" className="qty-btn" aria-label="Adicionar" onClick={() => duplicateDish(item.originalIndices[item.originalIndices.length - 1])}>+</button>
              </>
            ) : (
              <>
                <p className="status-request-pend status-pending-blinking">pendente</p>
                <p className="cancel" onClick={() => deleteRequest(item.originalIndices[0])}>
                  Cancelar
                </p>
                <button type="button" className="qty-btn" aria-label="Adicionar" onClick={() => duplicateDish(item.originalIndices[0])}>+</button>
              </>
            )}
          </div>
        ))
      ) : (
        <p className="no-request">Não há pedidos por enquanto</p>
      )}
      </div>

      <div
        ref={isToten ? undefined : footerFixedRef}
        className={(stylePdv || isToten) ? undefined : 'request-footer-fixed'}
        style={(!stylePdv && !isToten && footerBox.width) ? { left: `${footerBox.left}px`, width: `${footerBox.width}px` } : undefined}
      >

      {userData && Array.isArray(userData.request) && userData.request.length > 0 && (
        <div className="total-request-sum" style={stylePdv ? undefined : {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '80%',
          margin: '20px 10% 10px 10%',
          padding: '15px 10px',
          borderTop: '2px solid var(--secundary-bg-color)',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          color: 'var(--title-font-color)'
        }}>
          <span>Total do Pedido:</span>
          <span>
            R$ {finalPriceRequest ? finalPriceRequest.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) : '0,00'}
          </span>
        </div>
      )}
      <div className={stylePdv ? 'pdv-footer-actions' : (isToten ? '' : 'customer-footer-actions')}>
        <div className="btnFinalRequest">
          <button className="keep-shopping" onClick={handleRoute}>
            Continue Comprando
          </button>
        </div>
        <div className="btnFinalRequest">
          <button
            disabled={
              isSubmitting || 
              (!userData?.request || userData.request.length === 0) || 
              (!isPdvMode && !stylePdv && !global.orderBeingEdited && isTableClient && !allRequestsReady)
            }
            className="send-request"
            onClick={handleFinalizeButtonClick}
          >
            {isSubmitting 
              ? "ENVIANDO..." 
              : (deliveryAddress 
                  ? "Fazer Pedido (Entrega)" 
                  : (isPdvMode || stylePdv || global.orderBeingEdited)
                    ? "Finalizar" 
                    : isTableClient 
                      ? "Pedir a conta" 
                      : "Finalizar")}
          </button>
        </div>
      </div>
      </div>

      {stylePdv && !global.orderBeingEdited?.tableNumber && (
        <div style={{ margin: '6px 0', textAlign: 'center' }}>
          <label htmlFor="manual-table" style={{ display: 'block', marginBottom: '2px', fontWeight: 'bold', fontSize: '0.85rem' }}>
            Acrescente sua Mesa:
          </label>
          <input 
            id="manual-table"
            type="number" 
            placeholder="Nº da Mesa"
            value={manualTableNumber}
            onChange={(e) => setManualTableNumber(e.target.value)}
            style={{ 
              padding: '4px 8px', 
              borderRadius: '4px', 
              border: '1px solid var(--btn-color)', 
              textAlign: 'center',
              width: '85px',
              backgroundColor: 'white',
              color: '#333',
              fontSize: '0.85rem',
              cursor: 'text'
            }}
          />
        </div>
      )}
      {stylePdv && global.orderBeingEdited?.tableNumber && (
        <div style={{ margin: '6px 0', textAlign: 'center', fontWeight: 'bold', fontSize: '0.88rem', color: 'var(--title-font-color)' }}>
          Mesa: {global.orderBeingEdited.tableNumber} (Editando Pedido)
        </div>
      )}

      {stylePdv && (
        <div style={{ margin: '6px 0 8px 0', textAlign: 'center' }}>
          <button
            type="button"
            className="register-new-customer-btn"
            onClick={() => navigate('/create-customer', { state: { directRegister: true } })}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--btn-color, #d97706)',
              textDecoration: 'underline',
              fontWeight: 'bold',
              fontSize: '0.85rem',
              cursor: 'pointer',
              padding: '2px 6px'
            }}
          >
            Cadastre novo cliente
          </button>
        </div>
      )}

      {/* Bill Popups Refactored */}
      {billPopUpStep === 1 && (
        <BillFeedbackPopup 
          serviceRating={serviceRating}
          setServiceRating={setServiceRating}
          foodRating={foodRating}
          setFoodRating={setFoodRating}
          waiterComment={waiterComment}
          setWaiterComment={setWaiterComment}
          onCancel={() => setBillPopUpStep(0)}
          onConfirm={() => setBillPopUpStep(2)}
        />
      )}

      {billPopUpStep === 2 && (
        <BillSummaryPopup 
          requests={userData.request}
          subtotal={finalPriceRequest}
          includeServiceCharge={includeServiceCharge}
          setIncludeServiceCharge={handleServiceChargeChange}
          serviceChargeActive={Boolean(global?.serviceChargeActive)}
          serviceChargePercent={Number(global?.serviceChargePercent) || 10}
          billClosingMessage={global?.billClosingMessage}
          isProcessingPayment={isProcessingPayment}
          onBack={() => setBillPopUpStep(1)}
          onPay={handlePaymentFinalization}
        />
      )}
    </section>
  );
};
export default RequestModal;
//testando git
